import React from "react";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";

import Spinner from "@cloudscape-design/components/spinner";
import Box from "@cloudscape-design/components/box";
import Header from "@cloudscape-design/components/header";
import Container from "@cloudscape-design/components/container";
import Alert from "@cloudscape-design/components/alert";
import Button from "@cloudscape-design/components/button";
import Modal from "@cloudscape-design/components/modal";
import Multiselect from "@cloudscape-design/components/multiselect";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Table from "@cloudscape-design/components/table";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userStore } from "../stores/access";
import { taskManagerStore } from "../stores/taskManager";

class Translation extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			modalVisible: false,
			selectedBrands: [],
			selectedType: { label: "All", value: "all" },
		};

		this.intervalId = null;
		this.props.Interface.loadTaskList();
	}

	componentDidMount() {
		this.intervalId = setInterval(() => {
			this.props.Interface.loadTaskList();
		}, 15000);
	}

	componentWillUnmount() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	}


	handleOpenModal = () => {
		this.setState({ modalVisible: true });
	};


	handleCloseModal = () => {
		this.setState({ modalVisible: false, selectedBrands: [], selectedType: { label: "All", value: "all" } });
	};


	handleBrandChange = ({ detail }) => {
		this.setState({ selectedBrands: detail.selectedOptions });
	};


	handleTypeChange = ({ detail }) => {
		this.setState({ selectedType: detail.selectedOption });
	};


	handleStartTranslation = () => {
		const { selectedBrands, selectedType } = this.state;
		if (selectedBrands.length > 0) {
			this.props.Interface.startTranslation({
				brands: selectedBrands.map(option => option.value),
				type: selectedType.value,
			});
			this.handleCloseModal();
		}
	};

	render() {
		const { user, taskManager } = this.props;
		const { modalVisible, selectedBrands, selectedType } = this.state;


		const brandOptions = (user.brandsList || []).map(brand => ({
			label: typeof brand === "string" ? brand : brand.name,
			value: typeof brand === "string" ? brand : brand.id,
		}));


		const typeOptions = [
			{ label: "All", value: "all" },
			{ label: "Backend", value: "backend" },
			{ label: "Frontend", value: "frontend" },
		];

		return (
			<>
				{taskManager.loaded && taskManager.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={taskManager.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {taskManager.error.code} | request timestamp: {taskManager.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Container
					header={
						<Header
							actions={
								<SpaceBetween direction="horizontal" size="s">
									<Button onClick={this.handleOpenModal} variant="normal">
										Reload language
									</Button>
								</SpaceBetween>
							}
							description="Translation"
						>
							Translation
						</Header>
					}
				>
					<SpaceBetween direction="vertical" size="m">
						<Table
							columnDefinitions={[
								{
									id: "id",
									header: "ID",
									cell: item => item.id,
								},
								{ id: "name", header: "Name", cell: item => item.name },
								{
									id: "status",
									header: "Status",
									cell: item => item.status,
								},
								{
									id: "date",
									header: "Date",
									cell: item => (
										<>
											{new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString()}
										</>
									),
								},
							]}
							items={taskManager.data}
							loading={!taskManager.loaded}
							empty="No task found"
						/>
					</SpaceBetween>
				</Container>


				<Modal
					visible={modalVisible}
					onDismiss={this.handleCloseModal}
					header="Select Projects and Translation Type"
					footer={
						<Box float="right">
							<SpaceBetween direction="horizontal" size="xs">
								<Button variant="link" onClick={this.handleCloseModal}>
									Cancel
								</Button>
								<Button
									variant="primary"
									onClick={this.handleStartTranslation}
									disabled={selectedBrands.length === 0}
								>
									Start Translation
								</Button>
							</SpaceBetween>
						</Box>
					}
				>
					<SpaceBetween direction="vertical" size="m">
						<Box variant="h3">Projects</Box>
						<Multiselect
							selectedOptions={selectedBrands}
							onChange={this.handleBrandChange}
							options={brandOptions}
							placeholder="Choose projects"
							empty="No projects available"
							deselectAriaLabel={option => `Remove ${option.label}`}
						/>
						<Box variant="h3">Translation Type</Box>
						<Select
							selectedOption={selectedType}
							onChange={this.handleTypeChange}
							options={typeOptions}
							placeholder="Choose translation type"
						/>
					</SpaceBetween>
				</Modal>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const user = useRecoilValue(userStore);
		const taskManager = useRecoilValue(taskManagerStore);
		const setTaskManager = useSetRecoilState(taskManagerStore);

		return <Component {...props} user={user} taskManager={taskManager} setTaskManager={setTaskManager} />;
	};
}

export default withRecoil(Translation);